const stripTags = (str:string) => str
  .replaceAll(/(<\/?(strong|b|i|em|del[^>]+)>)/ig, '')
  .replaceAll(/(<([^>]+)>)/ig, ' ')
  .substring(0, 75)
  .replaceAll(/[\n]+|[\s]{2,}/gi, ' ');

export default stripTags;
